<div class="fpr-page" [class.fpr-page--dialog]="dialogRef">

  <!-- ── LOADING ──────────────────────────────────────────────── -->
  <div class="fpr-loading" *ngIf="!ready">
    <div class="fpr-loading__icon"><mat-icon>group</mat-icon></div>
    <div class="cf-dlg-loading__dots"><span></span><span></span><span></span></div>
    <p class="fpr-loading__text">Cargando formulario…</p>
  </div>

  <ng-container *ngIf="ready">

    <!-- ── HEADER (modo página) ───────────────────────────────── -->
    <div class="fpr-header" *ngIf="!dialogRef">
      <div class="fpr-header__icon"><mat-icon>group</mat-icon></div>
      <div>
        <h1 class="fpr-header__title">{{ financiacionPrivada.uid ? 'Editar financiación privada' : 'Nueva financiación privada' }}</h1>
        <p class="fpr-header__sub">{{ financiacionPrivada.uid ? 'Modifica los datos' : 'Registra una nueva financiación privada' }}</p>
      </div>
      <button mat-flat-button class="fpr-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>

    <!-- ── HEADER (modo dialog) ──────────────────────────────── -->
    <div mat-dialog-title class="fpr-dlg-title" *ngIf="dialogRef">
      <div class="fpr-dlg-title__left">
        <div class="fpr-header__icon"><mat-icon>group</mat-icon></div>
        <span>Financiación privada</span>
      </div>
      <button mat-icon-button (click)="closeDialog()" aria-label="Cerrar">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <!-- ── AVISO IMPORTACIÓN ─────────────────────────────────── -->
    <div class="fpr-import-notice" *ngIf="flagImport">
      <mat-icon>info</mat-icon>
      <span><strong>Importación:</strong> {{ movement.reference }}</span>
    </div>

    <!-- ── BODY ───────────────────────────────────────────────── -->
    <div class="fpr-body" [class.fpr-body--dialog]="dialogRef">
      <form onkeypress="return event.keyCode != 13;">
        <div class="fpr-grid">

          <!-- COLUMNA IZQUIERDA -->
          <div class="fpr-left">

            <!-- SECCIÓN: Identificación -->
            <div class="fpr-section">
              <div class="fpr-section__head">
                <mat-icon>perm_identity</mat-icon>
                <span>Identificación</span>
              </div>
              <div class="fpr-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Duración</mat-label>
                  <mat-select [(ngModel)]="financiacionPrivada.duracion" name="duracion" required>
                    <mat-option [value]="1">Corto Plazo — 521</mat-option>
                    <mat-option [value]="2">Largo Plazo — 171</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-input inputType="text" placeholder="Descripción" [isRequired]="true"
                  [(ngModel)]="financiacionPrivada.descripcion"></app-input>

              </div>
            </div>

            <!-- SECCIÓN: Plazos -->
            <div class="fpr-section">
              <div class="fpr-section__head">
                <mat-icon>date_range</mat-icon>
                <span>Plazos</span>
              </div>
              <div class="fpr-section__body">

                <div class="fpr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de constitución</mat-label>
                    <input matInput [matDatepicker]="fechaConstitucion" name="financiacionPrivada.fechaConstitucion"
                      [(ngModel)]="financiacionPrivada.fechaConstitucion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaConstitucion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaConstitucion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Plazo (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="financiacionPrivada.plazo"
                      name="financiacionPrivada.plazo" required>
                  </mat-form-field>
                </div>

                <div class="fpr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Fecha de finalización</mat-label>
                    <input matInput [matDatepicker]="fechaFinalizacion" name="financiacionPrivada.fechaFinalizacion"
                      [(ngModel)]="financiacionPrivada.fechaFinalizacion" required>
                    <mat-datepicker-toggle matSuffix [for]="fechaFinalizacion"></mat-datepicker-toggle>
                    <mat-datepicker #fechaFinalizacion></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Carencia (meses)</mat-label>
                    <input matInput type="number" [(ngModel)]="financiacionPrivada.carencia"
                      name="financiacionPrivada.carencia" required>
                  </mat-form-field>
                </div>

              </div>
            </div>

          </div>

          <!-- COLUMNA DERECHA -->
          <div class="fpr-right">

            <!-- SECCIÓN: Importes y condiciones -->
            <div class="fpr-section">
              <div class="fpr-section__head">
                <mat-icon>attach_money</mat-icon>
                <span>Importes y condiciones</span>
              </div>
              <div class="fpr-section__body">

                <div class="fpr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe inicial</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPrivada.importeInicial"
                      name="financiacionPrivada.importeInicial" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Importe pendiente</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPrivada.importePendiente"
                      name="financiacionPrivada.importePendiente" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

                <div class="fpr-two-col">
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Comisión apertura</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPrivada.comisionApertura"
                      name="financiacionPrivada.comisionApertura" numberDecimalsDirective required>
                  </mat-form-field>

                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>Tipo de interés</mat-label>
                    <input matInput type="text" [(ngModel)]="financiacionPrivada.tipoInteres"
                      name="financiacionPrivada.tipoInteres" numberDecimalsDirective required>
                  </mat-form-field>
                </div>

              </div>
            </div>

            <!-- SECCIÓN: Liquidaciones y cuenta -->
            <div class="fpr-section">
              <div class="fpr-section__head">
                <mat-icon>account_balance_wallet</mat-icon>
                <span>Liquidaciones y cuenta</span>
              </div>
              <div class="fpr-section__body">

                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Tipo de liquidaciones</mat-label>
                  <mat-select [(ngModel)]="financiacionPrivada.tipoLiquidaciones" name="tipoLiquidaciones" required>
                    <mat-option [value]="0">Sin seleccionar</mat-option>
                    <mat-option [value]="1">Mensual</mat-option>
                    <mat-option [value]="2">Bimensual</mat-option>
                    <mat-option [value]="3">Trimestral</mat-option>
                    <mat-option [value]="4">Semestral</mat-option>
                    <mat-option [value]="5">Anual</mat-option>
                  </mat-select>
                </mat-form-field>

                <app-autocomplete-select [items]="bankAccounts"
                  [(selectedItemId)]="financiacionPrivada.bankAccountsUid"
                  [idField]="'uid'" [displayFields]="['bank', 'iban']"
                  placeholder="Cuenta de adeudo" class="w-100">
                </app-autocomplete-select>

              </div>
            </div>

          </div>

        </div>
      </form>
    </div>

    <!-- ── ACTIONS (modo dialog) ────────────────────────────── -->
    <mat-dialog-actions align="end" *ngIf="dialogRef">
      <button mat-stroked-button (click)="closeDialog()">Cancelar</button>
      <button mat-flat-button class="fpr-btn-save" (click)="save()">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </mat-dialog-actions>

  </ng-container>

</div>
